import {
    ExpandableContentShowMoreComponent as SourceExpandableContentShowMoreComponent,
} from 'SourceComponent/ExpandableContentShowMore/ExpandableContentShowMore.component';

import './ExpandableContentShowMore.override.style';
import React from "react";
import FilterSwatchOptions from 'Component/FilterSwatchOptions';

export class ExpandableContentShowMoreComponent extends SourceExpandableContentShowMoreComponent {
    static propTypes = {
        updateConfigurableVariant: this.propTypes
    };

    constructor(props) {
        super(props)

        this.handleOptionClick.bind(this);
    }

    handleOptionClick = ({ attribute_code = '', attribute_value = '' }) => {
        const { updateConfigurableVariant } = this.props;

        if (updateConfigurableVariant) {
            updateConfigurableVariant(attribute_code, attribute_value);
        }
    }

    renderAttributeSwitch(option) {
        const { attribute_values = [], attribute_code } = option;
        const attributevalue = Object.values(option.attribute_options);

        const { children, showElemCount } = this.props;

        const child = children.slice(0, showElemCount);

        <FilterSwatchOptions
            attribute_code={attribute_code}
            attributevalue={attributevalue}
            option={option}
            attribute_values={attribute_values}
            handleOptionClick={this.handleOptionClick}
            isSelected={false}
        />
    }

    renderContent() {
        const { children, showElemCount } = this.props;

        const child = children.slice(0, showElemCount);

        return (
            <>
                {
                    this.renderAttributeSwitch(child[0]?.props?.attribute)
                }
            </>
        );
    }
}

export default ExpandableContentShowMoreComponent;
